// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_b2cb54d3f3e9d6025690cfbd61b701ff"};